import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CategoryDetail from './components/CategoryDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageCategory',
  components: {
    CategoryDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;